module.exports = __webpack_public_path__ + "media/images/logo-white-0a04e69775b95ed1fbda6e10697a4b8b.png";